
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import demo from './demo/input.twig';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Meta title="Objects/Form Group" mdxType="Meta" />
    <h1>{`Form Group`}</h1>
    <p>{`The Form Group layout object groups a label and its corresponding control.`}</p>
    <h2>{`Default`}</h2>
    <Canvas mdxType="Canvas">
  <Story name="Default" parameters={{
        docs: {
          source: {
            code: `{% embed '@cloudfour/objects/form-group/form-group.twig' with { label: 'Email' } only %}
  {% block control %}
    {% include '@cloudfour/components/input/input.twig' with { type: 'email' } only %}
  {% endblock %}
{% endembed %}`
          }
        }
      }} mdxType="Story">
    {() => demo()}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`class`}</inlineCode>{`: Append a class to the root element.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`label`}</inlineCode>{`: Label text (can be either a block or a variable)`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`control`}</inlineCode>{` (block): Block to add controls/inputs.`}</li>
    </ul>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;

export const defaultStory = (() => demo());
defaultStory.storyName = 'Default';
defaultStory.parameters = { storySource: { source: '() => demo()' }, ...{
  docs: {
    source: {
      code: `{% embed '@cloudfour/objects/form-group/form-group.twig' with { label: 'Email' } only %}
  {% block control %}
    {% include '@cloudfour/components/input/input.twig' with { type: 'email' } only %}
  {% endblock %}
{% endembed %}`
    }
  }
} };

const componentMeta = { title: 'Objects/Form Group', includeStories: ["defaultStory"],  };

const mdxStoryNameToKey = {"Default":"defaultStory"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;